const CHANGE_COLUMN_SORT = 'CHANGE_COLUMN_SORT'
const REMOVE_COLUMN_SORT = 'REMOVE_COLUMN_SORT'

export {
    CHANGE_COLUMN_SORT,
    REMOVE_COLUMN_SORT
}